import { Application } from 'pixi.js';

export type RendererHandle = {
  app: Application;
  canvas: HTMLCanvasElement;
  destroy: () => void;
};

export async function createRenderer(canvas: HTMLCanvasElement): Promise<RendererHandle> {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const app = new Application();
  await app.init({
    canvas,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundAlpha: 0,
    antialias: true,
    resolution: dpr,
    autoDensity: true,
    preference: 'webgl',
    powerPreference: 'high-performance',
  });

  return {
    app,
    canvas,
    destroy: () => {
      app.destroy(true);
    },
  };
}
